import React from 'react';
import { styled } from '@compiled/react';
import { fontSize } from '@atlassian/jira-common-styles/src';
import { TruncatedContentWrapper, TruncatedContentInner } from '../truncated-content';

import { TEXT_WIDTH, TEXT_HEIGHT } from './constants';

type Props = {
	x: number;
	y: number;
	children: string;
};

export const ProjectNameText = ({ x, y, children }: Props) => (
	<TruncatedContentWrapper width={TEXT_WIDTH} height={TEXT_HEIGHT} x={`${x}`} y={`${y}`}>
		<TruncatedProjectNameInner width={TEXT_WIDTH} height={TEXT_HEIGHT}>
			{children}
		</TruncatedProjectNameInner>
	</TruncatedContentWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TruncatedProjectNameInner = styled(TruncatedContentInner)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSize}px`,
	fontWeight: 700,
});
